/* eslint-disable react/prop-types */
/**
 * @file Pump.jsx
 * @exports PumpDefault
 */
import React from 'react'
import Running from './Running'
import Stopped from './Stopped'
import ShouldBeRunning from './ShouldBeRunning'

const PumpDefault = function PumpDefault ({
  style,
  running,
  shouldBeRunning,
  stopped,
  viewBox = '0 0 75 75'
}) {
  return (
    <Pump
      style={style}
      running={running}
      shouldBeRunning={shouldBeRunning}
      stopped={stopped}
      viewBox={viewBox}
    />
  )
}

export default PumpDefault

export const Pump = function Pump ({
  style,
  running,
  shouldBeRunning,
  stopped,
  viewBox,
}) {
  const svgStyle = style || { fill: '#284047' }
  return (
    <svg
      style={{
        fillRule: 'nonzero',
        clipRule: 'evenodd',
        strokeLinejoin: 'round',
        strokeMiterlimit: 1.4,
        ...svgStyle,
      }}
      viewBox={viewBox || '0 0 75 75'}
    >
      <description>pump icon</description>
      <title>pump</title>
      <g
        style={{
          transform: 'translate(4px, 16px) scale(1.7)',
        }}
      >
        <path
          stroke='none'
          d='M33.671,5l-3.4,-1.3c-0.1,0 -0.2,-0.1 -0.3,-0.1l-5.5,0l0,-1.5c0,-0.2 -0.1,-0.3 -0.2,-0.5l-1.3,-1.4c-0.2,-0.1 -0.4,-0.2 -0.5,-0.2l-4.3,0c-0.4,0 -0.7,0.3 -0.7,0.7l0,3l-4.9,0l-0.6,0l-2,0c-1.5,0 -2.7,1.2 -2.7,2.7l0,1.2l-0.7,0c-0.7,-0.1 -1.2,0.4 -1.2,1.1l0,2.7l-2.2,0c-0.4,0 -0.7,0.2 -0.7,0.6c0,0.4 0.3,0.7 0.7,0.7l2.2,0l0,2.7c0,0.7 0.5,1.2 1.2,1.2l0.7,0l0,1.2c0,1.5 1.2,2.7 2.7,2.7c0.7,0 5.5,0 6.3,0l0,1.3l-3,0c-0.4,0 -0.7,0.3 -0.7,0.7l0,2.5c0,0.4 0.3,0.7 0.7,0.7l14.2,0c0.4,0 0.7,-0.3 0.7,-0.7l0,-2.6c0,-0.4 -0.3,-0.7 -0.7,-0.7l-3,0l0,-1.3l5.4,0c0.1,0 0.1,0 0.3,-0.1l3.4,-1.3c0.3,-0.1 0.4,-0.3 0.4,-0.6l0,-12.8c0.1,-0.3 -0.1,-0.5 -0.3,-0.6Zm-21.1,6l16.7,0l0,1.8l-16.7,0l0,-1.8Zm16.7,-1.3l-16.7,0l0,-1.8l16.7,0l0, 1.8Zm-16.7,4.3l16.7,0l0,1.8l-16.7,0l0,-1.8Zm6.1, -12.7l3.4,0l1,1.1l0,1.3l-4.4,0l0,-2.4Zm10.6,3.6l0,1.6l-16.7,0l0,-1.6c5.9,0 10.5,0 16.7,0Zm-22.6,10.3l0,-6.4l0.5,0l0,6.4l-0.5,0Zm1.8,2.5c0, -5.9 0,-5.5 0,-11.3c0,-0.7 0.6,-1.4 1.4,-1.4l1.4,0l0,14.1l-1.4,0c-0.8,-0.1 -1.4,-0.7 -1.4,-1.4Zm4.1,-0.6l16.7,0l0,1.9l-16.7,0l0,-1.9Zm14.2,7.2l-12.9,0l0, -1.3l12.9,0l0,1.3Zm-3.5,-2.6l-5.7,0l0,-1.3l5.7,0l0,1.3Zm9.4,-3.8l-2.1,0.8l0,-13.4l2.1,0.7l0,11.9Z'
        />
        <path
          stroke='none'
          d='M21.571,1.8l-1.4,0c-0.5,0 -0.7,0.2 -0.7,0.6c0,0.4 0.3,0.7 0.7,0.7l1.4,0c0.4,0 0.7,-0.3 0.7,-0.7c0,-0.4 -0.3,-0.6 -0.7,-0.6Z'
        />
      </g>
      {running && (
        <g id='running' transform='translate(40,40),scale(.4)'>
          <Running />
        </g>
      )}
      {stopped && (
        <g id='stopped' transform='translate(40,40),scale(.4)'>
          <Stopped />
        </g>
      )}
      {shouldBeRunning && (
        <g id='should-be-running' transform='translate(40,40),scale(.4)'>
          <ShouldBeRunning />
        </g>
      )}
    </svg>
  )
}
